//@flow
import React from 'react';
import { useNavigate } from 'react-router-dom';
import classes from './DashboardCardContainerWithFlow.module.css';

const DashboardCardContainer = ({
	children,
	to = null,
	...rest
}: any) => {
	const navigate = useNavigate();
	const handleClick = () => {
		if (to) {
			navigate(to);
		}
	};
	
	return (
		<div 
			className={classes.CardContainer}
			{...(to ? { onClick: handleClick, style: { cursor: 'pointer' } } : {})}
			{...rest}
		>
			{children}
		</div>
	);
};

export default DashboardCardContainer;

/*
			{...(to
				? {
						onClick: navigate,
						style: { cursor: 'pointer' }
				  }
				: {})}
			{...rest}
*/
